import { render, staticRenderFns } from "./VerifyMicrosoft.vue?vue&type=template&id=6186d866&scoped=true"
import script from "./VerifyMicrosoft.vue?vue&type=script&lang=js"
export * from "./VerifyMicrosoft.vue?vue&type=script&lang=js"
import style0 from "./VerifyMicrosoft.vue?vue&type=style&index=0&id=6186d866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186d866",
  null
  
)

export default component.exports